// extracted by mini-css-extract-plugin
export default {"title":"SidebarShowError_title__luUHM","children":"SidebarShowError_children__911qD"};